
class Storage {
    constructor() { }

    get(name: string) {
        return localStorage.getItem(name);
    }

    set(name: string, value: any) {
        localStorage.setItem(name, value);
    }

    token(token?: string) {
        if (token || token === "") {
            localStorage.setItem("sso_token", token);
        } else {
            return localStorage.getItem("sso_token");
        }
    }

    email(email?: string) {
        if (email || email === "") {
            localStorage.setItem("sso_email", email);
        } else {
            return localStorage.getItem("sso_email");
        }
    }

    clear() {
        localStorage.clear();
    }

    remove(name: string) {
        localStorage.removeItem(name);
    }

    getObject(name: string) {
        try {
            return JSON.parse(localStorage.getItem(name) || "");
        } catch (e) { }
    }

    setObject(name: string, obj: any) {
        try {
            localStorage.setItem(name, JSON.stringify(obj));
        } catch (e) { }
    }
}

export default Storage;